const initialState = {
  devicesInfo: [],
  netError: null,
};

export default (state = initialState, action) => {
  let currentState = state;
  switch (action.type) {
    case "FETCH_DEVICES_DATA_SUCCESS":
      currentState = { ...state, devicesInfo: action.payload, netError: null };
      break;

    case "FETCH_DEVICES_DATA_FAILURE":
      currentState = { ...state, netError: action.error };
      break;

    default:
  }
  return currentState;
};
